// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CheckboxCheckedFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from checkbox-checked-filled.svg
 */
export default function CheckboxCheckedFilledIcon(
  props: CheckboxCheckedFilledIconProps,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CheckboxCheckedFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.18 3.636a.75.75 0 0 0-1.044.184l-4.588 6.552-1.655-2.758-.05-.072a.75.75 0 0 0-1.236.844l2.25 3.75.053.078a.75.75 0 0 0 1.204-.034l5.25-7.5.05-.08a.75.75 0 0 0-.234-.964"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
